import React from 'react';

import { useToastStore } from '@/store/apps/toastStore';

import type { ToastType } from './types';

export default function ToastContainer() {
  const { toasts, closeToast } = useToastStore();

  const toastHandler = (fn: ToastType['onClose'], id: ToastType['id']) => {
    fn?.();
    closeToast(id);
  };

  return (
    <div className="pointer-events-none fixed left-0 top-0 z-[11000] flex h-full w-full flex-col-reverse items-center justify-end gap-2.5 pt-5 lg:pt-12">
      {toasts.map(
        (
          { id, component: ToastComponent, message, state, onClose }: ToastType,
          index,
        ) =>
          ToastComponent && (
            <ToastComponent
              id={id}
              key={id}
              index={index}
              message={message}
              state={state}
              toastClose={() => toastHandler(onClose, id)}
            />
          ),
      )}
    </div>
  );
}
